const sideMenu = [
  {
    id: "events",
    label: "Events",
    href: "/app/event",
    permissions: [1, 7]
  },
  {
    id: "tickets",
    label: "Tickets",
    href: "/app/ticket",
    permissions: [1, 2, 7]
  },
  {
    id: "redeem",
    label: "Redeem",
    href: "/app/redeem",
    permissions: [1, 2]
  },
  {
    id: "double-redeem",
    label: "Double Redeem",
    href: "/app/double-redeem",
    permissions: [1, 2]
  },
  {
    id: "checkin",
    label: "Check In",
    href: "/app/checkin",
    permissions: [1, 3, 5]
  },
  {
    id: "checkout",
    label: "Check Out",
    href: "/app/checkout",
    permissions: [1, 4, 5]
  },
  {
    id: "userlist",
    label: "User Management",
    href: "/app/users",
    permissions: [7, 99]
  }
];

export default sideMenu;
